import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import SizeDependedBlock from 'components/SizeDependedBlock';
import Slider from 'components/sliders/Slider';
import Thumbnail from 'components/Thumbnail';
import { useLightbox } from 'hooks/useLightbox';

import { screenBreakpoints } from 'utils/helpers/constants';
import CommonPropTypes from 'utils/propTypes/common';

import styles from './styles.module.scss';

const Gallery = ({ material }) => {
	const [lightbox, showLightbox] = useLightbox(material.files);

	const getParamsImage = useCallback((file) => {
		const maxWidth = 600;

		return {
			width: maxWidth,
			height: parseInt((file.height / file.width) * maxWidth, 10)
		};
	}, []);

	const getStylesImageMobile = useCallback((file) => {
		const mobileHeight = 200;

		return {
			width: `${parseInt((file.width / file.height) * mobileHeight, 10)}px`
		};
	}, []);

	const renderImages = useCallback(
		(isSlides) =>
			material.files.map((file, index) => (
				// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
				<div
					key={file._id}
					className={isSlides ? styles.itemSlide : styles.itemImage}
					style={
						isSlides
							? getStylesImageMobile(file)
							: { flexGrow: file.width / file.height }
					}
					onClick={() => showLightbox(index)}
				>
					<Thumbnail
						file={file}
						params={getParamsImage(file)}
						alt={file.meta?.title}
						keepRatio
					/>
				</div>
			)),
		[getParamsImage, getStylesImageMobile, showLightbox, material]
	);

	return material.type === 'photo' ? (
		<>
			<SizeDependedBlock breakpointMobile={screenBreakpoints.mobileMedium}>
				<Slider
					theme="mobileEdge"
					params={{
						spaceBetween: 8
					}}
				>
					{renderImages(true)}
				</Slider>
				<div className={styles.block}>{renderImages(false)}</div>
			</SizeDependedBlock>
			{lightbox}
		</>
	) : null;
};

Gallery.propTypes = {
	material: PropTypes.shape({
		_id: PropTypes.number.isRequired,
		type: PropTypes.string,
		files: PropTypes.arrayOf(CommonPropTypes.file).isRequired
	}).isRequired
};

export default Gallery;
